module.exports = __webpack_public_path__ + "img/compare-2.934ba3bb.jpg";